import _ from 'lodash';

/**
 * Get an array containing all tenants
 * @param {*} state
 */
export const getTenantsAsArray = (state: string): string[] => {
  const entities = _.get(state, ['entities', 'tenants', 'byId'], {});
  const result = Object.keys(entities).map((code): string => entities[code]);
  return result;
};

export default {
  getTenantsAsArray,
};
